import { useCallback } from 'react';
import { DayOfWeek } from '../API/Enums';
import { useLocalization } from '../context/Localization/localization';

export const useLocalizedDayOfWeek = () => {
    const Localization = useLocalization();

    return useCallback((day: DayOfWeek) => {
        switch (day) {
            case DayOfWeek.Sunday:
                return Localization.Sunday;
            case DayOfWeek.Monday:
                return Localization.Monday;
            case DayOfWeek.Tuesday:
                return Localization.Tuesday;
            case DayOfWeek.Wednesday:
                return Localization.Wednesday;
            case DayOfWeek.Thursday:
                return Localization.Thursday;
            case DayOfWeek.Friday:
                return Localization.Friday;
            case DayOfWeek.Saturday:
                return Localization.Saturday;
        }
    }, [Localization]);
};